import { Menu, Transition } from "@headlessui/react";
import {
  CheckCircleIcon,
  CheckBadgeIcon,
  EllipsisHorizontalIcon,
  ViewfinderCircleIcon,
  BookmarkIcon,
} from "@heroicons/react/24/outline";
import { Fragment } from "react";
import { useNavigate } from "react-router-dom";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function ActionMenu({
  provider,
  handleShowDocDetailsClick = null,
  urlLink = null,
  onActionClick = null,
  hideRequestActions = false,
}) {
  const navigate = useNavigate();
  const handleBookmark = () => {
    console.log("Bookmark toggled");
    // TODO: Implement bookmark functionality
  };

  const handleViewDetails = (e) => {
    e.preventDefault();
    if (onActionClick) {
      onActionClick();
    } else if (urlLink) {
      window.location.href = urlLink;
    }
  };
  return (
    <Menu as="div" className="relative ml-auto">
      <Menu.Button className="-m-2.5 block p-2.5 text-gray-400 hover:text-gray-500 focus:outline-none">
        <span className="sr-only">Open options</span>
        <EllipsisHorizontalIcon className="h-5 w-5" aria-hidden="true" />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 mt-0.5 w-40 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
          <Menu.Item className="flex items-center">
            {({ active }) => (
              <button
                onClick={handleViewDetails}
                className={classNames(
                  active ? "bg-gray-50" : "",
                  "w-full flex items-center px-3 py-1 text-sm leading-6 text-gray-900 cursor-pointer text-left"
                )}
              >
                <ViewfinderCircleIcon className="w-[16px] h-[16px]" />{" "}
                <div className="pl-2" onClick={handleShowDocDetailsClick}>
                  View Details
                </div>
              </button>
            )}
          </Menu.Item>
          {!hideRequestActions && (
            <Menu.Item className="flex items-center">
              {({ active }) => (
                <button
                  onClick={() => navigate(`/RFI/Create?id=${provider.id}`)}
                  className={classNames(
                    active ? "bg-gray-50" : "",
                    "block px-3 py-1 text-sm leading-6 text-gray-900 cursor-pointer"
                  )}
                >
                  <CheckCircleIcon className="w-[16px] h-[16px] text-indigo-700" />
                  <div className="pl-2">Request VQQ</div>
                  <span className="sr-only">Request VQQ</span>
                </button>
              )}
            </Menu.Item>
          )}
          {!hideRequestActions && (
            <Menu.Item className="flex items-center">
              {({ active }) => (
                <button
                  onClick={() => navigate(`/Assessment/Create?id=${provider.id}`)}
                  className={classNames(
                    active ? "bg-gray-50" : "",
                    "block px-3 py-1 text-sm leading-6 text-gray-900 cursor-pointer"
                  )}
                >
                  <CheckBadgeIcon className="w-[16px] h-[16px] text-rose-700" />
                  <div className="pl-2">Request VQA</div>
                  <span className="sr-only">Request VQA</span>
                </button>
              )}
            </Menu.Item>
          )}
          <Menu.Item className="flex items-center">
            {({ active }) => (
              <button
                onClick={handleBookmark}
                className={classNames(
                  active ? "bg-gray-50" : "",
                  "flex w-full px-3 py-1 text-sm leading-6 text-gray-900 cursor-pointer"
                )}
              >
                <BookmarkIcon className="w-[16px] h-[16px]" />
                <div className="pl-2">Bookmark</div>
              </button>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}

export default ActionMenu;
